import { combineReducers } from 'redux';

import { gradProgramsReducer as gradPrograms } from './gradPrograms';

export const gradSchoolsReducer = combineReducers({
  gradPrograms,
});
